import { Box, IconButton, Link as ChakraLink } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { TbReportAnalytics } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CTable from "../../../components/Table/table";
import { openAddLiveVideo } from "../../../modules/admin-modules/models/Actions";
import { deleteAdminSectionRequest } from "../../../modules/admin-modules/sections/Actions";

const C = {
  primary: "#6A1E1E",
  secondary: "#4A0F1F",
  border: "#D8CEC3",
};

const iconBtnProps = {
  variant: "ghost",
  border: "0",
  size: "sm",
  color: C.primary,
  _hover: { bg: "rgba(106, 30, 30, 0.08)", color: C.secondary },
};

const LiveVideosTable = ({ setAdd, setSelectedData, searchTerm = "" }) => {
  const liveVideos = useSelector((state) => state.adminLiveVideos.liveVideos);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector((state) => state.adminLiveVideos.isLoading);
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const list = useMemo(() => {
    const raw = Array.isArray(liveVideos) ? liveVideos : [];
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return raw;
    return raw.filter(
      (v) =>
        v?.title?.toLowerCase().includes(q) ||
        v?.zoom_link?.toLowerCase().includes(q)
    );
  }, [liveVideos, searchTerm]);

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  const viewData = (row) => {
    const plain = list.find((v) => v.id === row?.id) ?? row;
    setSelectedData(plain);
  };

  const Data = list.map((data) => ({
    ...data,
    id: data?.id,
    name: data?.title,
    link: (
      <ChakraLink
        href={data?.zoom_link}
        isExternal
        color={C.primary}
        fontWeight="700"
        textDecoration="underline"
        onClick={(e) => e.stopPropagation()}
      >
        {data?.zoom_link || "—"}
      </ChakraLink>
    ),
    report: (
      <Box
        as="button"
        type="button"
        cursor="pointer"
        color={C.primary}
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/dashboard/live-videos-report/${data?.id}`);
        }}
        aria-label="Open report"
      >
        <TbReportAnalytics size={22} />
      </Box>
    ),
    edit: (
      <IconButton
        {...iconBtnProps}
        aria-label="Edit live session"
        fontSize="20px"
        icon={<RiFileEditLine />}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedData(data);
          setAdd(false);
          dispatch(openAddLiveVideo());
        }}
      />
    ),
    delete: (
      <IconButton
        {...iconBtnProps}
        aria-label="Delete"
        fontSize="20px"
        icon={<RiDeleteBinLine color="#9b2c2c" />}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(deleteAdminSectionRequest(data?.id));
        }}
      />
    ),
  }));

  const columns = [
    { Header: "Session", accessor: "name" },
    { Header: "Link", accessor: "link" },
    { Header: "Report", accessor: "report" },
    { Header: "Edit", accessor: "edit" },
    { Header: "Delete", accessor: "delete" },
  ];

  const totalPage = Math.max(1, Math.ceil(list.length / size));

  return (
    <Box px={{ base: 4, md: 8 }} pb={10} w="100%">
      <Box
        bg="rgba(255,255,255,0.9)"
        border="1px solid"
        borderColor={C.border}
        borderRadius="16px"
        overflow="hidden"
        boxShadow="sm"
      >
        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path="openModel"
          Title=""
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar
          noFilter
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar
          isLoading={isLoading}
          perPage={size}
          totalPage={totalPage}
          wrapperProps={{ maxH: "unset", overflow: "auto" }}
          tableProps={{ bg: "transparent", borderRadius: "0", mb: 0 }}
          theadProps={{ bg: "#D8CEC3", color: "#4A0F1F" }}
        />
      </Box>
    </Box>
  );
};

export default LiveVideosTable;
